import {INTERNAL_CLOCK} from '../actions/types';

const INITIAL_STATE = {
  difference_time_stamp: 0,
};

const InternalClock = (
  state = INITIAL_STATE,
  action: {type: String; payload: {difference_time_stamp: string | number}},
) => {
  switch (action.type) {
    case INTERNAL_CLOCK:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default InternalClock;
